<style scoped>
  .btn-group {
    padding-left: 20px;
  }
</style>
<template>
  <div>
    <h3 class="title">系统用户列表
      <Button type="primary" @click="to_add()" style="float: right;">新增</Button>
      <Button @click="to_reset_more()" style="float: right;margin-right: 10px;">批量重置密码</Button>
    </h3>
    <div>
      <Table ref="selection" border :columns="d_columns" :data="d_data" @on-selection-change="get_select_data"></Table>
    </div>
    <Modal
      v-model="d_modal_add"
      :title="d_modal_title"
      footer-hide>
      <Form ref="formValidate" :model="add_params" :rules="ruleValidate" :label-width="100">
        <FormItem label="用户名" prop="Name">
          <Input v-model="add_params.Name" placeholder="请输入用户名"></Input>
        </FormItem>
        <FormItem label="手机号码" prop="Phone">
          <Input v-model="add_params.Phone" placeholder="请输入手机号码"></Input>
        </FormItem>
        <FormItem label="密码" prop="Password" v-if="d_modal_type=='add'">
          <Input v-model="add_params.Password" placeholder="请输入用户名"></Input>
        </FormItem>
        <FormItem label="部门名称" prop="DepartName">
          <Input v-model="add_params.DepartName" placeholder="请输入部门名称"></Input>
        </FormItem>
        <FormItem label="设置角色权限" prop="RoleCode">
          <Select v-model="add_params.RoleCode">
            <Option v-for="(item,index) in d_role_data" :value="item.Code" :key="index">{{ item.Name }}<span style="color: grey">({{item.Code}})</span></Option>
          </Select>
          <!--<Table border ref="selection" height="200" :columns="d_role_columns" :data="d_role_data" @on-selection-change="get_select_roles"></Table>-->
        </FormItem>

        <FormItem>
          <Button type="primary" @click="edit_confirm('formValidate')">保存</Button>
          <Button @click="add_modal_cancel" style="margin-left: 8px">取消</Button>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
  import apiSystem from '@/api/system.js';
  import apiRole from '@/api/role.js';
  export default {
    name:'systemInfo_page',
    data() {
      return {
        d_page: 1,
        d_page_size: 100,
        d_modal_add: false,
        d_columns: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '编号',
            key: 'ID'
          },
          {
            title: '名称',
            key: 'Name'
          },
          {
            title: '手机号码',
            key: 'Phone'
          },
          {
            title: '行业',
            key: 'DepartName'
          },
          {
            title: '所属角色',
            key: 'RoleName'
          },
          {
            title: "操作",
            key: "do",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.to_edit(params.row);
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: "提示",
                          content: "<p>您确认要删除该条数据吗？</p>",
                          onOk: () => {
                            this.to_delete(params.row)
                          }
                        });
                      }
                    }
                  },
                  "删除"
                ),
                h(
                  "Button",
                  {
                    props: {
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.to_reset(params.row)
                      }
                    }
                  },
                  "重置密码"
                )
              ])
            }
          }
        ],
        d_data: [],
        add_params:{}, // 编辑需要传的参数
        ruleValidate: {
          Name: [
            {required: true, message: '用户名不能为空', trigger: 'blur'}
          ],
          Phone: [
            {required: true, message: '手机号码不能为空', trigger: 'blur'}
          ],
          Password: [
            {required: true, message: '密码不能为空', trigger: 'blur'}
          ],
          DepartName: [
            {required: true, message: '部门名称不能为空', trigger: 'blur'}
          ]
        },
        d_modal_type: '', // 如果是添加打开的modal，就传add，如果是编辑打开的modal，就传edit，因为是同一个modal
        d_modal_title:'',
        d_role_columns:[
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '角色主键',
            key: 'Code'
          },
          {
            title: '角色名称',
            key: 'Name'
          }
        ],
        d_role_data:[],
        d_reset_data: ''
//        d_reset_data:{}
      };
    },
    methods: {
      pull_data() {
        let _this = this;
        apiSystem.getSysUserInfoList().then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){ //登录成功+执行成功
            let requestResult = _data.data.Data;
            _this.d_data = requestResult; //数据列表开始
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      to_add(){
        this.d_modal_add = true;
        this.d_modal_type = 'add';
        this.d_modal_title = '添加系统用户';
        this.add_params.ID = 0;
        this.add_params.Name = '';
        this.add_params.Phone = '';
        this.add_params.Password = '';
        this.add_params.DepartName = '';
        this.add_params.RoleCode = [];
      },
      to_edit(row){
        this.d_modal_type = 'edit';
        this.d_modal_title = '编辑系统用户';
        this.add_params.ID = row.ID;
        this.add_params.Name = row.Name;
        this.add_params.Phone = row.Phone;
        this.add_params.Password = row.Password;
        this.add_params.DepartName = row.DepartName;
        this.add_params.RoleCode = row.RoleCode;
        this.$refs['formValidate'].validate((valid)=> {});//重新验证，不然会有提示
        this.d_modal_add = true;
      },
      to_delete(row){
        apiSystem.del(row.ID).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            this.$Message.success('删除成功');
            this.pull_data();
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      to_reset(row){ //这个拿来保存单个重置
        this.reset_pwd(row.ID);
      },
      to_reset_more(){
        if(this.d_reset_data.length>0){
          this.reset_pwd(this.d_reset_data);//这个拿来保存批量重置
        }else {
          this.$Message.warning('请选择要删除的列');
        }
      },
      reset_pwd(dataId){
        apiSystem.resetPassword(dataId).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){ //登录未失效+执行成功
            this.pull_data();
            this.$Message.success('密码重置成功');
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      add_modal_cancel(){
        this.d_modal_add = false;
      },
      edit_confirm (name) {
        let _this = this;
        this.$refs[name].validate((valid) => {
          if (valid) {
            if(_this.d_modal_type=='add'){
              apiSystem.add.post(this.add_params).then((_data) => {
                if(_data.data.ExeSuccess && _data.data.LoginSuccess){ //登录未失效+执行成功
                  this.d_modal_add = false;
                  this.pull_data();
                }else {
                  this.$Message.error(_data.data.Msg);
                }
              });
            }else if(_this.d_modal_type=='edit'){
              apiSystem.edit.post(this.add_params).then((_data) => {
                if(_data.data.ExeSuccess && _data.data.LoginSuccess){ //登录未失效+执行成功
                  this.d_modal_add = false;
                  this.pull_data();
                }else {
                  this.$Message.error(_data.data.Msg);
                }
              });
            }
          } else {
            this.$Message.error('验证失败!');
          }
        })
      },
      get_select_data(row){
        let str = ''
        for(let i=0;i<row.length;i++){
          str += row[i].ID+',';
        }
        str=(str.substring(str.length-1)==',')?str.substring(0,str.length-1):str; // 去掉末尾逗号
        this.d_reset_data = str;
      },
      get_roleList() {
        let _this = this;
        apiRole.getRoleList.post({PageIndex: 1, PageSize: 100}).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){ //登录成功+执行成功
            let requestResult = _data.data.Data;
            _this.d_role_data = requestResult.RowsList; //数据列表开始
//            console.log(_this.d_role_data);
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
    },
    computed: {
    },
    created() {
      this.add_params = JSON.parse(JSON.stringify(apiSystem.add.data));
      this.pull_data();
      this.get_roleList();//获取角色列表，方便添加
    }
  }
</script>






